import {
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { combineLatest, filter, map, startWith, takeUntil } from 'rxjs';
import { Messages } from '../../../messages/Messages';

import { AsyncPipe } from '@angular/common';
import { BerufeService } from '../../../services/suchseite/berufe.service';
import { Mode, TypeaheadComponent } from '../../typeahead/typeahead.component';
import { CleanupService } from '../../../shared/utils/cleanup.service';
import { SuchwortService } from '../../../services/suchseite/suchwort.service';

@Component({
  selector: 'now-wbsuche-lib-textsuche',
  templateUrl: './textsuche.component.html',
  styleUrls: ['textsuche.component.scss'],
  providers: [CleanupService],
  imports: [TypeaheadComponent, AsyncPipe]
})
export class TextsucheComponent implements AfterViewInit {
  suchwortService = inject(SuchwortService);
  private readonly berufeService = inject(BerufeService);
  private readonly cleanupService = inject(CleanupService);
  public readonly hilfstext =
    'Geben Sie möglichst genau an, wonach Sie suchen. Je mehr Begriffe, desto besser das Ergebnis - zum Beispiel „Digitalisierung Büro Verwaltung“.';

  @Input()
  public inputElementId = '';

  @Output()
  public dataChange = new EventEmitter<void>();

  @ViewChild(TypeaheadComponent)
  public typeahead!: TypeaheadComponent;

  public messages = Messages;

  public initialSuchwort$ = combineLatest([
    this.berufeService.bezeichnung$.pipe(startWith('')),
    this.suchwortService.suchwort$.pipe(startWith(''))
  ]).pipe(
    map(([beruf, suchwort]) => {
      return suchwort || beruf;
    })
  );

  constructor() {
    this.setInitialSuchwortFromBeruf();
  }

  private setInitialSuchwortFromBeruf() {
    this.berufeService.bezeichnung$
      .pipe(
        takeUntil(this.cleanupService.destroyed$),
        filter((bezeichnung) => !!bezeichnung)
      )
      .subscribe((bezeichnung) => this.suchwortService.setSuchwortFuerSpaetereSuche(bezeichnung));
  }

  public async onSelected() {
    this.dataChange.emit();
  }

  protected readonly Mode = Mode;

  ngAfterViewInit(): void {
    this.typeahead.inputContent$
      .pipe(takeUntil(this.cleanupService.destroyed$))
      .subscribe((value) => {
        this.suchwortService.setSuchwortFuerSpaetereSuche(value);
      });
  }
}
